import { render, staticRenderFns } from "./DataMatrixReader.vue?vue&type=template&id=7377b9a0&scoped=true&"
import script from "./DataMatrixReader.vue?vue&type=script&lang=js&"
export * from "./DataMatrixReader.vue?vue&type=script&lang=js&"
import style0 from "./DataMatrixReader.vue?vue&type=style&index=0&id=7377b9a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7377b9a0",
  null
  
)

export default component.exports